module.exports = function(app) {
    app.directive('pcnValidation', ["$window", "$compile", function($window, $compile) {
        return {
            restrict: "A",
            require: "ngModel",
            link: function (scope, elm, attrs, ctrl) {

                ctrl.$validators.pcnValidation = function (modelValue, viewValue) {


                    return true;
                    /*var today = new Date();
                    var enteredDate = modelValue;
                    var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                    var firstDayOfMonthMinus3Y = new Date(firstDayOfMonth.getFullYear() - 3, firstDayOfMonth.getMonth(), 1);
                    var todayPlus90D = new Date(today.getFullYear(), today.getMonth(), today.getDate()+90);
                    var firstDayOfMonthMinus6Mo = new Date(firstDayOfMonth.getFullYear() , firstDayOfMonth.getMonth() - 6, 1);
                    var firstDayOfMonthMinus1Mo = new Date(firstDayOfMonth.getFullYear() , firstDayOfMonth.getMonth() - 1, 1);
                    var d15thPrePre = new Date(firstDayOfMonth.getFullYear() , firstDayOfMonth.getMonth() - 2, 15);


                    var nDays = enteredDate - firstDayOfMonth;

                    if (scope.asoValue) {
                        return ( (enteredDate > firstDayOfMonthMinus3Y) && (enteredDate < todayPlus90D) );
                    }
                    else {
                        if (scope.employee.data.subscriber.cobra)
                            return ( (enteredDate > d15thPrePre) && (enteredDate < todayPlus90D) );
                        else
                            return ( (enteredDate > firstDayOfMonthMinus1Mo) && (enteredDate < todayPlus90D) );

                    }*/
                };

            }
        };
    }]);
}
